import React from "react";

import { ConfiguratorTypes } from "../../../constants";
import { IImageURL } from "../../../models/nominals";
import { BreakPoint } from "../../../models/screen.interfaces";
import { getViewportBreakpoint } from "../../../utils/detectMobile";
import { FreeDeliveryButtonTypes } from "../constants";
import { IModularConfiguratorShippingMessage } from "../models.interfaces";
import { ConfiguratorFreeDelivery } from "./ConfiguratorFreeDelivery";

import styles from "./ConfiguratorShippingCallout.module.scss";

interface IOwnProps {
    content: string;
    configuratorType: ConfiguratorTypes;
    shippingMessages?: IModularConfiguratorShippingMessage | null;
    phoneNumber?: string;
    iconURL?: IImageURL | null | undefined;
}

interface IReduxProps {}

interface IProps extends IOwnProps, IReduxProps {}

interface IState {}

// TODO(ssr, LEVEL 2 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 2/10 due to 71 LOC, simple presentational component with viewport breakpoint detection, straightforward content building with string replacement, and basic rendering logic.
export class ConfiguratorShippingCallout extends React.PureComponent<
    IProps,
    IState
> {
    private buildDescription() {
        let content = this.props.content;
        if (getViewportBreakpoint() > BreakPoint.SMALL) {
            content = content.replace("<br>", "");
        }
        return (
            <div className={styles.content}>
                {this.props.iconURL && (
                    <img
                        src={`${this.props.iconURL}`}
                        aria-hidden="true"
                        alt=""
                    />
                )}
                <span>
                    {content}
                    {!!this.props.shippingMessages && (
                        <ConfiguratorFreeDelivery
                            freeDeliveryButtonTypes={
                                FreeDeliveryButtonTypes.ICON
                            }
                            configuratorType={this.props.configuratorType}
                            phoneNumber={this.props.phoneNumber}
                            shippingMessages={this.props.shippingMessages}
                        />
                    )}
                </span>
            </div>
        );
    }
    render() {
        return (
            <>
                <div className={styles.container}>
                    {this.buildDescription()}
                </div>
            </>
        );
    }
}
